import React from "react";
import InView from "react-intersection-observer";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import {
  getImageOrVideoPath,
  handleChangeIntersection,
} from "../../shared/helpers";
import "./style.scss";

const SectionTopic = (props: any) => {
  const { sectionItem, history } = props;

  const colors: ISectionCSS = {
    "--color": sectionItem.color || "#000",
    "--colorTitle": sectionItem.color_title || "#000",
    "--colorContent": sectionItem.color_content || "#000",
  };

  const handleClick = (e: any, url: string = "/") => {
    e.preventDefault();
    history.push(url);
  };

  return sectionItem ? (
    <div style={colors} className="kd-section-topic">
      <div className="kd-section-topic-img">
        <img src={getImageOrVideoPath(sectionItem.images)} alt="" />
      </div>
      <div className="kd-section-topic-body">
        <InView
          triggerOnce
          onChange={(inView, entry) =>
            handleChangeIntersection(
              inView,
              entry,
              "background-color-to-bottom-animation"
            )
          }>
          <div className="kd-section-topic-body-content">
            <div className="kd-section-topic-body-content-title main-title">
              {sectionItem.title}
            </div>
            <div className="kd-section-topic-body-content-description main-content">
              {sectionItem.content}
            </div>
            <div className="kd-section-topic-body-content-action">
              <div
                onClick={(e: any) => handleClick(e, sectionItem.url)}
                className="arrow"
              />
            </div>
          </div>
        </InView>
      </div>
    </div>
  ) : null;
};

export default SectionTopic;
